import { Card, LoadingIndicator } from '@moia-dev/pace-web'
import type { ReactNode } from 'react'

export const LoadingLivestream = ({ children }: { children?: ReactNode }) => {
  return (
    <Card
      outline
      css={theme => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.semantic.ColorSurfaceReduced,
        minHeight: '300px',
      })}
    >
      {children ?? <LoadingIndicator />}
    </Card>
  )
}
